<template>
  <div id="app">
    <div class="flex-relative justify-center"
         style="   margin-top: 17px;height: 38px ;width: 100%;">
      <input type="text"
             class="input"
             v-model="search"
             placeholder="请输入关键词...">
      <button class="button"
              @click="clickInput"> <img src="../../assets/img/search.png"
             alt=""></button>

    </div>
    <div class=" bg-white margin-center   margin-top-15 backgroud"
         style="padding-top:10px;min-height: 550px;">

      <div class="flex flex-direction align-center ">

        <div v-for="(item, index) in dataList"
             :key="index"
             @click="articleIndex(item.Id)"
             :style="index!=0?'border-top: #eeeeee dashed 1px;':''"
             class="information">
          <div class="flex font-size-20 font-color-black"
               :title="item.Title"
               style="align-items: baseline;">
            <p class="text-line1 click"
               style="cursor: pointer;">{{item.Title}}</p>
            <span class=" font-size-14 font-color-999 "
                  style="text-align:left;width: 160px;margin-left: 15px;">{{item.CreateTime}}</span>

            <button @click.stop="onDelete(item.Id)">删除</button>
          </div>
          <p style="text-align: left;margin-top:14px"
             :title="item.Description"
             class=" font-size-14 font-color-999 text-line1">{{item.Description}}</p>
        </div>
        <div v-for="(item, index) in searchList"
             :key="index"
             @click="articleIndex(item.Id)"
             :style="index!=0?'border-top: #eeeeee dashed 1px;':''"
             class="information">
          <div class="flex font-size-20 font-color-black"
               :title="item.Title"
               style="align-items: baseline;">
            <p class="text-line1 click"
               v-html="item.Title"
               style="cursor: pointer;"></p>
            <span class=" font-size-14 font-color-999 "
                  style="text-align:left;width: 160px;margin-left: 15px;">{{item.CreateTimeStr}}</span>
            <button @click.stop="onDelete(item.Id)">删除</button>
          </div>
          <p style="text-align: left;margin-top:14px"
             :title="item.Description"
             v-html="item.Description"
             class=" font-size-14 font-color-999 text-line1"></p>

        </div>
      </div>
    </div>
    <div style=" margin-top: 20px; ">
      <el-pagination @size-change="handleSizeChange"
                     :current-page.sync="currentPage"
                     @current-change="handleCurrentChange"
                     :page-size="1"
                     layout="prev, pager, next"
                     :total="totalPage">
      </el-pagination>
    </div>
    <Bottom></Bottom>
  </div>
</template>

<script>
import common from "@/utils/common.js";
export default {
  name: 'app',

  data () {
    return {
      currentPage: 1,
      dataList: [],
      searchList: [],
      totalPage: 1,
      ChannelId: 0,
      search: '',

    }
  },


  mounted () {

    this.ChannelId = this.$route.params.ChannelId || 0;



    if (this.ChannelId == 0) {
      this.getCourseList(1)
    }

  },
  methods: {
    clickInput () {
      if (this.search == "") {
        return
      }
      this.dataList = [];
      this.currentPage = 1
      this.getSearchKey(this.currentPage)
    },
    getSearchKey (index) {

      var that = this;
      var params =
      {
        KeyWord: this.search,
        Type: 'article',
        PageIndex: index,
        PageSize: 16
      }

      this.getRequest('api/v1/search/SearchByKeyWord', params).then(data => {
        if (data.IsSuccess) {
          that.searchList = data.Data.Articles.DataList
          that.totalPage = data.Data.Articles.TotalPage



        } else {
          // this.$message.error(data.Message)
        }
      })

    },
    onDelete (Id) {

      var that = this;
      this.postRequest('api/v1/authorinfo/DeleteArticles', {
        Id: Id
      }).then(data => {

        if (data.IsSuccess) {
          that.getCourseList(that.currentPage)
        }
      })


    },
    articleIndex (Id) {
      this.$router.push({ path: '/infordes', query: { "Id": Id } })
    },
    checkCatalogsItem (index) {
      if (this.ChannelId != index) {
        this.ChannelId = index;
        this.getCourseList(1);
        this.currentPage = 1
      }

    },
    getCourseList (index) {
      var that = this;
      this.getRequest('api/v1/authorinfo/GetArticlesListByPage', {
        ChannelId: this.ChannelId,
        PageIndex: index,
        PageSize: 15
      }).then(data => {
        if (data.IsSuccess) {

          that.dataList = data.Data.DataList
          that.totalPage = data.Data.TotalPage
        } else {
          this.$message.error(data.Message)
        }
      })
    },
    handleSizeChange (val) {

    },
    handleCurrentChange (val) {

      window.scrollTo(0, 0)
      if (this.search == "") {
        this.searchList = [];
        this.getCourseList(val)
      } else {
        this.getSearchKey(val)
      }


    },

  }
}
</script>

<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

body {
  background: #ffffff;
  padding: 0 0;
}

.click:hover {
  color: #d30000;
}
.backgroud {
  width: 1220px;

  background: #ffffff;
  box-shadow: 0px 3px 20px 0px #ececec;
}
.information {
  box-sizing: border-box;
  width: 1159px;
  padding: 20px 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/views/searchaiticle/index.vue